
sap["ls"]["preload"]["UCF_Form"] = function() {/* global _assert, _trace, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * A Form, for purpose of JSF integration,
 * supports collection and transport of semantic events to the back-end

 * 
 * @version 1.0.0.0
 *
 * @class
 * @param {element} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Form(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Form["_"]["UCF_Form"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "Form.js(23): UCF_Form"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Form.js(24): UCF_Form"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Form.js(25): UCF_Form"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["defineEvents"](['Destroy']);
};window["UCF_Form"] = UCF_Form; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Form"); UCF_Form["_"] = {UCF_Form: 0}; }; ;
UCF_Form["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Form.prototype["sClassName"] = "UCF_Form";

/**
 *Intializes event handlers for the form
 *@private
 */
UCF_Form["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["initialize"]++; }; 

	// store old submit handler reference on the DOM object !!
	this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"] = this["oDomRef"]["submit"];

	this["attachBrowserEvent"]("submit", this["oDomRef"]);
	this["attachBrowserEvent"]("reset", this["oDomRef"]);

	// for direct javascript calls the original handler has to be called
	var that = this;
	this["oDomRef"]["submit"] = function(event) {
		that["fireSubmit"](that["sId"]);
	};
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["initialize"] = 0; };

UCF_Form["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["destroy"]++; }; 
	if (this["oDomRef"]) {
		this["oDomRef"]["submit"] = null;
		this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"] = null;
	}

	// notify event handler, who has to delete form-related queue data
	this["fireEvent"](this["E_EVENTS"]["Destroy"], { "Id": this["sId"] });

	if (this["oDomRef"]) {
		this["detachBrowserEvent"]("submit", this["oDomRef"]);
		this["detachBrowserEvent"]("reset", this["oDomRef"]);
	}
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["destroy"] = 0; };

/**
 * onsubmit handler for browser event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Form["prototype"]["onsubmit"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["onsubmit"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Form.js(73): onsubmit"); };
	this["fireSubmit"](this["sId"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["onsubmit"] = 0; };

/**
 * mapi call allowing submit the form from other controls
 */
UCF_Form["prototype"]["submit"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["submit"]++; }; 
	this["oDomRef"]['_SAP_UCF_oldHandlerSubmit_']();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["submit"] = 0; };

/**
 * onreset handler for browser event.
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Form["prototype"]["onreset"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["onreset"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Form.js(90): onreset"); };
	this["fireReset"](this["sId"]);
	oBrowserEvent["cancel"]();
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["onreset"] = 0; };

/**
 * appends new hidden field to the form
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Form["prototype"]["appendHiddenField"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["appendHiddenField"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "Form.js(102): appendHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "", "sName != \"\"", "Form.js(103): appendHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Form.js(104): appendHiddenField"); };

	// Due to MSIE specialites (Aaagr!!!) we have to use following nasty code
	// see also:
	//   http://msdn2.microsoft.com/en-us/library/ms534184.aspx
	//   http://www.thunderguy.com/semicolon/2005/05/23/setting-the-name-attribute-in-internet-explorer/
	//   http://alt-tag.com/blog/archives/2006/02/ie-dom-bugs/
	var oElem = null;
	try {
		// MSIE nasty hack
		oElem = document["createElement"]("<input type='hidden' name='" + sName + "'/>");
		oElem["value"] = sValue;
		this["oDomRef"]["appendChild"](oElem);
	} catch (e) {}
	if (!oElem || oElem["nodeName"] != "INPUT") {
		// Non MSIE browser, take standard canonical methods for named element
		oElem = document["createElement"]("input");
		oElem["type"] = "hidden";
		oElem["name"] = sName;
		oElem["value"] = sValue;
		this["oDomRef"]["appendChild"](oElem);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["appendHiddenField"] = 0; };

/**
 * associates new value to given form field. if such field not yet
 * exists, it is automatically created.
 * @param {string} sName
 * @param {string} sValue
 */
UCF_Form["prototype"]["putHiddenField"] = function(sName, sValue) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenField"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sName) == "string", "typeof(sName) == \"string\"", "Form.js(136): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "", "sName != \"\"", "Form.js(137): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sValue) == "string", "typeof(sValue) == \"string\"", "Form.js(138): putHiddenField"); };

	//all names that are function on this.oDomRef.elements are not supported
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "id", "sName != \"id\"", "Form.js(141): putHiddenField"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sName != "name", "sName != \"name\"", "Form.js(142): putHiddenField"); };

	// Check whether the form contains the hidden field
	// with given name - conside there can be more of them
	var oElem = this["oDomRef"]["elements"][sName];
	if (oElem) {
		if (oElem["length"]) {
			// several elements found, iterate backwards and find first right match
			for (var i = oElem["length"] - 1; i >= 0; i--) {
				if (oElem[i] && oElem[i]["type"] && (oElem[i]["type"] == "hidden")) {
					oElem[i]["value"] = sValue;
					return;
				}
			}
		} else {
			// single node found, just try this
			if (oElem && oElem["type"] && (oElem["type"] == "hidden")) {
				oElem["value"] = sValue;
				return;
			}
		}
	}

	// not found, add it to the current form
	this["appendHiddenField"](sName, sValue);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenField"] = 0; };

/**
 * creates or modifies hidden form fields specified by name/value map
 * @private
 */
UCF_Form["prototype"]["putHiddenFieldsByMap"] = function(mFieldMap) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenFieldsByMap"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(mFieldMap) == "object", "typeof(mFieldMap) == \"object\"", "Form.js(175): putHiddenFieldsByMap"); };
	for (var sName in mFieldMap) {
		this["putHiddenField"](sName, mFieldMap[sName]);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["putHiddenFieldsByMap"] = 0; };

/**
 * Sets the action method / URL of the form, SubmitMethod, see also ActionMethod property on control interface
 * @param {String} sActionMethod
 */
UCF_Form["prototype"]["setActionMethod"] = function(sActionMethod) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setActionMethod"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sActionMethod) == "string", "typeof(sActionMethod) == \"string\"", "Form.js(187): setActionMethod"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sActionMethod != "", "sActionMethod != \"\"", "Form.js(188): setActionMethod"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.action changed to:" + sActionMethod, "Form.js(189): setActionMethod"); };

	this["oDomRef"]["action"] = sActionMethod;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setActionMethod"] = 0; };

/**
 * Sets the submit method of the form, see also SubmitMethod property on control interface
 * @param {String} sSubmitMethod
 */
UCF_Form["prototype"]["setSubmitMethod"] = function(sSubmitMethod) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setSubmitMethod"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sSubmitMethod) == "string", "typeof(sSubmitMethod) == \"string\"", "Form.js(200): setSubmitMethod"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sSubmitMethod != "", "sSubmitMethod != \"\"", "Form.js(201): setSubmitMethod"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.method chagned to:" + sSubmitMethod, "Form.js(202): setSubmitMethod"); };

	this["oDomRef"]["method"] = sSubmitMethod;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setSubmitMethod"] = 0; };

/**
 * Sets the Target of the form, see also Target property on control interface
 * @param {String} sTarget
 */
UCF_Form["prototype"]["setTarget"] = function(sTarget) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setTarget"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sTarget) == "string", "typeof(sTarget) == \"string\"", "Form.js(213): setTarget"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sTarget != "", "sTarget != \"\"", "Form.js(214): setTarget"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Form.target changed to:" + sTarget, "Form.js(215): setTarget"); };

	this["oDomRef"]["target"] = sTarget;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setTarget"] = 0; };

/**
 * Sets the action of the form
 *
 * @param {String} sAction
 */
UCF_Form["prototype"]["setAction"] = function(sAction) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setAction"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAction) == "string", "typeof(sAction) == \"string\"", "Form.js(226): setAction"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAction != "", "sAction != \"\"", "Form.js(227): setAction"); };

	this["oDomRef"]["action"] = sAction;
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setAction"] = 0; };

/**
 * Returns the action of the form
 */
UCF_Form["prototype"]["sGetAction"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["sGetAction"]++; }; 
	return this["oDomRef"]["action"];
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["sGetAction"] = 0; };

/**
 * Saves the content of all autocomplete enabled fields in this form
 */
UCF_Form["prototype"]["saveAutoComplete"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["saveAutoComplete"]++; }; 
	if (window["external"] && "AutoCompleteSaveForm" in window["external"]) {
		window["external"]["AutoCompleteSaveForm"](this["oDomRef"]);
	} else {
		var sEncType = this["oDomRef"]["enctype"];

		this["oDomRef"]["enctype"] = "application/x-www-form-urlencoded";

		this["oDomRef"]["_SAP_UCF_oldHandlerSubmit_"]();

		this["oDomRef"]["enctype"] = sEncType;
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["saveAutoComplete"] = 0; };

/** WDA only: for stateless until REST channel was established
 * @deprecated
 * @public
 */
UCF_Form["prototype"]["getId"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["getId"]++; }; 
	return this["sId"];
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["getId"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aAttributeNames"] = ["bHasEventQueue","sResponseData","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aEventNames"] = ["Submit","Reset","Request"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Form["prototype"]["aMethodNames"] = ["submit","appendHiddenField","putHiddenField","setActionMethod","setSubmitMethod","setTarget","getId","saveAutoComplete","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_Form["prototype"]["bHasEventQueue"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.FormResponseData}
 */
UCF_Form["prototype"]["sResponseData"] = "FULL";

/**
 * @private
 * @type {string}
 */
UCF_Form["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Form["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Form["_"]["setDefaultValues"]++; }; 
	this["bHasEventQueue"] = false;
	this["sResponseData"] = "FULL";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("HasEventQueue", false, true);
		this["setClientProperty"]("ResponseData", "FULL", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Form::Submit
 */
UCF_Form["prototype"]["fireSubmit"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireSubmit"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Form.js(327): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(328): fireSubmit"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(329): fireSubmit"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Form", "Submit", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireSubmit"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control in the current HTML document context. The Id of any control should be unique within the document.
 * @fires Form::Reset
 * @deprecated
 */
UCF_Form["prototype"]["fireReset"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireReset"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Form.js(347): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(348): fireReset"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(349): fireReset"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Form", "Reset", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireReset"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the page control
 * @param {boolean} bAsync Determines whether the request is sent synchronously (false,default) or asynchronously(true)
 * @param {string} sFocusInfo Detailed focus information including cursor position and internal control settings. Pass this string to the method setFocus() on the page to the client in order to apply the focus information again after a roundtrip.
 * @param {string} sHash Hash part of the current URL
 * @param {boolean} bDomChanged Determines whether the client side browser dom was changed on the client by a user interaction after the last request.
 * @param {boolean} bIsDirty Deterimines the current value of Dirty Flag needed for WorkProtect feature.
 * @fires Form::Request
 */
UCF_Form["prototype"]["fireRequest"] = function(sId, bAsync, sFocusInfo, sHash, bDomChanged, bIsDirty) {;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireRequest"]++; }; 
	/** @type {{Id: string, Async: boolean, FocusInfo: string, Hash: string, DomChanged: boolean, IsDirty: boolean}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 6, "arguments.length == 6", "Form.js(371): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Form.js(372): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Form.js(373): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bAsync != null, "bAsync != null", "Form.js(374): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bAsync) == "boolean", "typeof(bAsync) == \"boolean\"", "Form.js(375): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sFocusInfo != null, "sFocusInfo != null", "Form.js(376): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sFocusInfo) == "string", "typeof(sFocusInfo) == \"string\"", "Form.js(377): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHash != null, "sHash != null", "Form.js(378): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHash) == "string", "typeof(sHash) == \"string\"", "Form.js(379): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bDomChanged != null, "bDomChanged != null", "Form.js(380): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bDomChanged) == "boolean", "typeof(bDomChanged) == \"boolean\"", "Form.js(381): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(bIsDirty != null, "bIsDirty != null", "Form.js(382): fireRequest"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(bIsDirty) == "boolean", "typeof(bIsDirty) == \"boolean\"", "Form.js(383): fireRequest"); };
	mParams = {
		"Id": sId,
		"Async": bAsync,
		"FocusInfo": sFocusInfo,
		"Hash": sHash,
		"DomChanged": bDomChanged,
		"IsDirty": bIsDirty
	};
	
	
	
	
	
	
	this["fireSemanticEvent"]("Form", "Request", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Form["_"]["fireRequest"] = 0; };

UCF_Form.prototype["aPublicMethods"] = ["getId"].concat(UCF_Form.prototype.aPublicMethods || []);
};